<template>
  <div class="automation">
    <div style="margin-bottom: 10px">
      <el-button
        style="float: left; margin-right: 10px"
        @click="goBack"
        type="primary"
        ><i class="fas fa-arrow-left"></i> Go Back</el-button
      >
      <div style="float: left">
        <el-input
          class="inline-input"
          v-model="keyword"
          placeholder="Search name, tags"
          :trigger-on-focus="false"
          style="width: auto"
          clear
        ></el-input>
        <el-select v-model="showType" placeholder="Select Type">
          <el-option key="any" label="All" value="" />
          <el-option key="template" label="Template" value="template" />
          <el-option key="header" label="Header" value="header" />
          <el-option key="footer" label="Footer" value="footer" />
        </el-select>
      </div>
      <el-button
        style="float: right"
        @click="action('edit', 'new')"
        type="primary"
        >+ Add new Email Template</el-button
      >
    </div>
    <div style="clear: both"></div>
    <hr style="margin-top: 10px" />
    <el-table
      :data="
        data
          .filter((itm) => {
            if (!keyword) {
              return itm;
            } else {
              if (
                itm.title.toLowerCase().includes(keyword.toLowerCase()) ||
                (itm.description &&
                  itm.description
                    .toLowerCase()
                    .includes(keyword.toLowerCase())) ||
                (itm.description &&
                  itm.subject.toLowerCase().includes(keyword.toLowerCase()))
              ) {
                return itm;
              }
            }
          })
          .filter((itm) => {
            if (showType && itm.automation_type === showType) {
              return itm;
            } else if (!showType) {
              return itm;
            }
          })
      "
      style="width: 100%"
      :default-sort="{ prop: 'first_name', order: 'ascending' }"
      v-loading="loading"
    >
      <!-- <el-table-column prop="when" label="Actions" sortable>
        <template slot-scope="scope">
          <div :key="action.id" v-for="action in scope.row.actions">
            <small>{{ child }}</small>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="parent" label="Parent" sortable></el-table-column> -->
      <el-table-column
        prop="id"
        label="Id"
        sortable
        width="100"
      ></el-table-column>
      <el-table-column prop="title" label="Title" sortable></el-table-column>
      <el-table-column
        prop="user_type"
        label="User type"
        sortable
      ></el-table-column>
      <el-table-column
        prop="subject"
        label="Email subject"
        sortable
      ></el-table-column>
      <el-table-column prop="global" label="Global" width="70">
        <template slot-scope="scope">
          <i
            class="fas fa-check"
            style="color: green"
            v-if="scope.row.global"
          ></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="Created"
        sortable
      ></el-table-column>
      <el-table-column
        prop="updated_at"
        label="Updated"
        sortable
      ></el-table-column>
      <el-table-column label="Actions" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            title="Edit"
            @click="action('edit', scope.row.id)"
            ><i class="fa-solid fa-pen-to-square"></i>
          </el-button>
          <el-button
            size="mini"
            type="warning"
            title="Duplicate"
            @click="action('duplicate', scope.row.id)"
            ><i class="fa-solid fa-copy"></i>
          </el-button>
          <el-popconfirm
            title="Are you sure you want to delete it?"
            @confirm="action('delete', scope.row.id)"
            class="ml-10px"
          >
            <el-button slot="reference" size="mini" type="danger"
              ><i class="fas fa-trash"></i
            ></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import ApiService from "@/services/ApiService";
export default {
  name: "MailgunTemplates",
  data() {
    return {
      data: [],
      showType: "",
      keyword: "",
      loading: false,
    };
  },
  methods: {
    goBack() {
      this.$router.push("/members/automations/");
    },
    action(type, id) {
      if (type === "edit") {
        this.$router.push("/members/automations/mailgun_templates/" + id);
      } else if (type === "delete") {
        ApiService.automationsApi.deleteItem("mailTemplate", id).then(() => {
          this.$notify.info({
            title: "Deleted",
            message: "Deleted!",
          });
          this.getTemplates();
        });
      } else if (type === "duplicate") {
        ApiService.automationsApi.duplicateItem("mailTemplate", id).then(() => {
          this.$notify.info({
            title: "Duplicated",
            message: "Duplicated!",
          });
          this.getTemplates();
        });
      }
    },
    getTemplates() {
      ApiService.automationsApi.getTemplates("email").then((resp) => {
        this.data = resp.data;
      });
    },
  },
  mounted() {
    this.getTemplates();
  },
};
</script>
